<template>
  <div
    class="w-full h-full overflow-scroll bg-gray-200 py-5 px-5 md:px-10 bg-general bg-center bg-cover"
  >
    <div
      class="flex text-2xl bg-white py-2 rounded-md shadow-xl"
      v-if="showSearchResults"
    >
      <img
        src="@/assets/icons/allhouse_Illustrations_Search.png"
        style="width: 44px"
      />Your Search Results
    </div>
    <ListingsReel v-if="showSearchResults" :listings="searchResults" />
    <div
      v-if="showSearchResults && searchResults.length < 1"
      class="bg-gray-100 rounded-md my-5 py-3"
    >
      <h3 class="text-center flex text-3xl w-full justify-center">
        Oops!
        <img src="@/assets/icons/monster.svg" width="50" />
      </h3>
      <h4 class="text-center w-full text-xl">
        We haven't listed any properties here just yet
        <br />
        PS... New properties are listed daily, so come back tomorrow
      </h4>
    </div>
    <div class="flex text-2xl bg-white py-2 rounded-md shadow-xl">
      <img
        src="@/assets/icons/icon-Rocket-ship.png"
        style="width: 44px"
      />Latest Listings
    </div>
    <ListingsReel :listings="latestListings" />
    <div class="flex text-2xl bg-white py-2 rounded-md shadow-xl">
      <img
        src="@/assets/icons/icon-emoji-smile.png"
        style="width: 44px"
      />Coolest Pads
    </div>
    <ListingsReel :listings="coolestPads" />
    <div class="flex text-2xl bg-white py-2 rounded-md shadow-xl">
      <img src="@/assets/icons/Icon-Fire.png" style="width: 44px" />Trending
      Properties
    </div>
    <ListingsReel :listings="trendingProperties" />
  </div>
</template>

<script>
import ListingsReel from "@/components/ListingsReel";
import { mapState } from "pinia";
import { useListingStore } from "@/store/listing";
export default {
  name: "ListingsView",
  components: { ListingsReel },
  computed: {
    ...mapState(useListingStore, [
      "latestListings",
      "coolestPads",
      "trendingProperties",
      "searchResults",
      "showSearchResults",
    ]),
  },
};
</script>

<style scoped></style>
